import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import backImg from "../../assets/img/icon_back.svg";
import analyticsLogEvent from "../../services/FirebaseService";
import {FIREBASE_SCREEN_NAMES, LOCALSTORAGE_ITEMS} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import {useLocation, useNavigate} from "react-router";
import 'react-phone-number-input/style.css';
import 'react-phone-input-2/lib/style.css'
import {getPhoneVerificationCodeHandler} from "../../handlers/HandlerUserProfile";
import CustomPhoneInput from "../../components/CustomPhoneInput";
import {PATH} from "../../routes/routes";
import { getAppLocale } from "../../util/common";


function PhoneUpdate() {
    const navigateTo = useNavigate();
    const tokenTs = StorageService.getItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN_TS) ? StorageService.getItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN_TS) : null;
    const unverifiedPhone = StorageService.getItem(LOCALSTORAGE_ITEMS.UNVERIFIED_PHONE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.UNVERIFIED_PHONE) : null;
    let userInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO)) : null;
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const countdown = query.get('countdown');


    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        phone: userInfo?.phone ? userInfo?.phone : null,
        isSubmitBtnEnabled: true,
        verificationCodeInfoFromServer: null,
    });



    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.PROFILE_UPDATE,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.PROFILE_UPDATE
        });

        if (tokenTs && unverifiedPhone) {
            let elapsedTime = new Date().getTime() - tokenTs;
            if (elapsedTime > 5 * 60 * 1000) {
                elapsedTime = 0;
            }else{
                elapsedTime = (5 * 60 * 1000) - elapsedTime;

            }

            if (elapsedTime > 0) {
                navigateTo(PATH.PROFILE_UPDATE_PHONE_PIN_CONFIRMATION + "/" + unverifiedPhone + (countdown? "?countdown="+countdown : ""));
            }
        }


    }, []);



    const goBack = () => {
        navigateTo(-1);
    }

    const handleOnChange = (phoneNumber) => {
        StorageService.setItem(LOCALSTORAGE_ITEMS.UNVERIFIED_PHONE, phoneNumber);
        setState({
            ...state,
            phone: phoneNumber
        });
    }






    const validatePhone = () => {

        if (!state.phone ||
            state.phone.trim() === "" ||
            state.phone.length < 8 ||
            state.phone.length > 15
        ) {
            setState({
                ...state,
                errorMsg: <FormattedMessage id="InvalidPhoneNumber" defaultMessage="InvalidPhoneNumber"/>,
            });
            return false;
        } else {
            return true;
        }
    }

    const bodyForVerificationCodeRequest = {
        "email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
        "phone": state.phone,
        "locale":getAppLocale()
    }

    const sendCodeVerification = async () => {
        if (validatePhone()) {

            await getPhoneVerificationCodeHandler(bodyForVerificationCodeRequest).then(response => {
                if (response.ok) {


                    if (Object.keys(response.data).length === 0) {
                        navigateTo(PATH.PROFILE_UPDATE_PHONE_PIN_CONFIRMATION + "/" + state.phone);
                    }else{
                        StorageService.setItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN, response.data.token);
                        StorageService.setItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN_TS, new Date().getTime());
                        navigateTo(PATH.PROFILE_UPDATE_PHONE_PIN_CONFIRMATION + "/" + state.phone);
                    }
                } else {
                    if (response.data.code === 403) {
                        if (response.data.status === "Forbidden") {
                            setState({
                                ...state,
                                errorMsg: <FormattedMessage id="Error.genericError" defaultMessage="Error.genericError"/>
                            })
                        }else{
                            setState({
                                ...state,
                                isSubmitBtnEnabled: true,
                                errorMsg: <FormattedMessage id="InvalidVerificationCode"/>,
                                loading: false,
                            })
                        }

                    }else{
                        setState({
                            ...state,
                            errorMsg: <FormattedMessage id="Error.genericError" defaultMessage="Error.genericError"/>
                        })
                    }
                }
            })
        }
    }




    return (
        <div className="page-content without-actionsbar">

            <div className="login-container">
                <a className="btn-back" onClick={goBack} data-qa="update-profile-back-btn"><img alt="back button" src={backImg}/></a>

                    <div className="login-container-content text-left">
                        <div className="login-container-content-top-text">

                           <>
                                <h3><FormattedMessage id="UpdateYourPhoneNumber"/></h3>
                                <br/>
                                <h5><FormattedMessage id="WeWillSendASmsCode"/></h5>
                                <br/>
                                <div className="form-group overflow-visible">
                                    <div className="row">
                                        <CustomPhoneInput
                                            value={state.phone}
                                            onChange={handleOnChange}
                                        />

                                    </div>

                                </div>
                            </>
                        </div>
                            <>
                                <div className="row">
                                    <button onClick={() => sendCodeVerification()}
                                            className={state.isSubmitBtnEnabled ?
                                                "btn btn-md btn-default uppercase register-btn"
                                                : "btn btn-md btn-default uppercase register-btn btn-disabled"}
                                            data-qa="update-profile-submit-btn">
                                        <FormattedMessage id="Continue" defaultMessage="Continue"/>
                                    </button>
                                </div>
                                {state.errorMsg != null ?
                                    <div className="row centered-content">
                                        <div className="error-div" data-qa="update-profile-error-div">
                                            <p>&#9888;&nbsp;{state.errorMsg}</p>
                                        </div>
                                    </div>


                                    : null
                                }
                            </>

                    </div>

            </div>
        </div>

    );
}

export default PhoneUpdate;
